import React, { useState } from 'react';
import FocusLock from 'react-focus-lock';
import i18next from 'i18next';
import { Icon } from '@workboard/action-item';
import styled from 'styled-components';
import KrModal from '../../components/okr/modals/kr-modal';
import GoalServices from '../../services/goal.services';
import { reactLoader, removeReactLoader } from '../../utils/common';
import { SetKrContainerHeight } from '../../utils/function';
import ReactionEmojiComp from '../../components/emojis/reaction-emojis';
import ScaleRange from '../../okr/modals/kr_update/scale-range';
import EmojiServices from '../../services/emoji.services';
import {KeyDownEvent} from '../../utils/eventKey';
import Loader from '../../components/common/SpinningLoader';

const IconWrapper = styled.span`
	margin-right: 15px;
	svg {
		vertical-align: middle;
	}
`;

/**
 * Class representing a Notification Component.
 *
 * @class
 */
class Notifications extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      data: props.notificationsData || [],
      showTray: false,
      showNotificationWindow: true,
      isNew: props.isNew || false,
      searchString: "",
      showSearch: false,
      showFilter: false,
      notificationFiltter: false,
      notifiFilterSelection: [1],
      filterText: "",
      userId: props.userId || 0,
      emojisData: {},
	  isdisabled:true,

    };
    this.deleteAll = this.deleteAll.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    const emojiServices = new EmojiServices();
    this._isMounted= true;
    emojiServices.getOrgEmojiLists()
      .then((response) => {
        if (response.data) {
          if (this._isMounted) {
            this.setState({
              emojisData: response.data.data
            });
          }
        }
      });
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keydown', this.handleEscape);
  }

  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleEscape);
  }

  deleteAll() {
    const { actions } = this.props;
    const ids = [];
    for (let i = 0; i < this.state.data.length; i++) {
      ids.push(this.state.data[i].data.id);
    }
    actions.NotificationsDeleteAll(ids);
  }

  handleChange() {
    this.setState({
      searchString: this.refs.search.value
    });
  }

  static getDerivedStateFromProps(props, state) {
    // console.log('getDerivedStateFromProps,', state, props);
    if (props.notificationsData.length !== state.data.length) {
    //   console.log('cond meet');
      return {
        data: props.notificationsData,
      };
    }
    if (props.userId !== state.userId) {
    //   console.log('cond meet userId');
      return {
        userId: props.userId,
      };
    }
    if (props.isNew !== state.isNew) {
    //   console.log('cond meet isNew');
      return {
        isNew: props.isNew,
      };
    }
    // Return null to indicate no change to state.
    return null;
  }

  showNotificationWindow() {
    this.setState({
      showTray: false,
      showNotificationWindow: true,
      isNew: false
    });
    this.props.resetNotification();
  }

  showMinimizedTray() {
    this.setState({
      showTray: true,
      showNotificationWindow: false,
      showSearch: false,
      searchString: ""
    }, () => {
      $(".notification-tray").draggable({ axis: "x", containment: "window" });
    });
  }

  hideNotificationWindow() {
    this.setState({
      showSearch: false,
      searchString: "",
      notificationFiltter: false,
      notifiFilterSelection: [1]
    }, () => {
      this.props.closeModal();
    });
  }

  /**
	 * @function toggleSearch
	 * @description Toggles the state of the search. When hiding, make sure to set the searchString val to empty string
	 */
  toggleSearch() {
    this.setState(prevState => ({
      showSearch: !prevState.showSearch,
      searchString: "",
    }));
  }

  /* filter show n hide dropdown */
  filteringToNotifications() {
    this.setState({
      showFilter: !this.state.showFilter
    });
  }

  applyFilter(event, item) {
    const { t } = this.props;
    event.preventDefault();
    const { notifiFilterSelection } = this.state;
    let newArr = [];
    const that = this;
    if (!notifiFilterSelection.includes(item)) {
      newArr = [...notifiFilterSelection, item];
    } else {
      newArr = notifiFilterSelection.filter(a => a !== item);
    }

    if (item == 1) {
      if (newArr.includes(2)) {
        newArr = newArr.filter(i => i != 2);
      }
      if (newArr.includes(3)) {
        newArr = newArr.filter(i => i != 3);
      }
    }
    if (item == 2 || item == 3) {
      if (newArr.includes(1)) {
        newArr = newArr.filter(i => i != 1);
      }
    }
    if (newArr.length == 0) {
      newArr = [1];
    }
    // console.log(newArr);

    if (newArr.includes(2) && newArr.includes(3)) {
      this.setState({
        filterText:
					`${i18next.t('Showing your')} ${t('OKR')} ${i18next.t('notifications and your assigned action items & @mentions')}`,
        notificationFiltter: true
      });
    } else if (newArr.includes(2)) {
      this.setState({
        filterText: i18next.t('Showing your assigned action items and @mentions'),
        notificationFiltter: true
      });
    } else if (newArr.includes(3)) {
      this.setState({
        filterText: `${i18next.t('Showing your')} ${t('OKR')} ${i18next.t('notifications')}`,
        notificationFiltter: true
      });
    } else {
      this.setState({
        filterText: "",
        notificationFiltter: false
      });
    }
    setTimeout(() => {
      that.setState({
        notifiFilterSelection: newArr
      });
    }, 0);
  }

  handleClickOutside(e) {
    if (
      !$(".notification-dropdown").is(e.target) &&
			$(".notification-dropdown").has(e.target).length === 0
    ) {
      if (this.state.showFilter) {
        this.setState({
          showFilter: !this.state.showFilter,
          filterText: this.state.filterText,
          notificationFiltter: true
        });
      }
    }
  }

  handleEscape = (e) => {
	if (e.key === 'Escape') {
		e.preventDefault();
		this.hideNotificationWindow();
		document.getElementById('notifications-icon-btn')?.focus();
	}
    if(e.key == 'Shift'||e.key == 'Tab'){
	this.setState({isdisabled:false})
    }else{
	this.setState({isdisabled:true})
     }
  }

  render() {
    const { t, isLoading } = this.props;
    let notifRow;
    let _data = this.state.data;
    const search = this.state.searchString.trim().toLowerCase();
    const notifHashMap = {};

    if (search.length > 0) {
      _data = _data.filter(data => {
        const description = data.data.description ? data.data.description : "";
        const userName = data.data.user_name ? data.data.user_name : "";
        const comment = data.data.comment ? data.data.comment : "";
        return (
          data.action_text
            .toLowerCase()
            .replace(/<(?:.|\n)*?>/gm, "")
            .includes(search.toLowerCase()) ||
					userName
					  .toLowerCase()
					  .replace(/<(?:.|\n)*?>/gm, "")
					  .includes(search.toLowerCase()) ||
					data.action_desc
					  .toLowerCase()
					  .replace(/<(?:.|\n)*?>/gm, "")
					  .includes(search.toLowerCase()) ||
					description
					  .toLowerCase()
					  .replace(/<(?:.|\n)*?>/gm, "")
					  .includes(search.toLowerCase()) ||
					comment
					  .toLowerCase()
					  .replace(/<(?:.|\n)*?>/gm, "")
					  .includes(search.toLowerCase())
        );
      });
    }
    if (
      this.state.notifiFilterSelection.length > 0 &&
			this.state.notifiFilterSelection.find(
			  element => element == 2 || element == 3
			)
    ) {
      const { notifiFilterSelection } = this.state;
      notifiFilterSelection.sort((a, b) => a - b);
      // let filterArrayText = this.state.notifiFilterSelection.toString();
      // console.log("filterText",filterText);
      if (notifiFilterSelection.length > 1) {
        _data = _data.filter(data => {
          const filterData = data.data.filter ? data.data.filter : "";
          // console.log(filter);
          return (
            filterData.includes(notifiFilterSelection[0]) ||
						filterData.includes(notifiFilterSelection[1])
          );
        });
      } else {
        _data = _data.filter(data => {
          const filterData = data.data.filter ? data.data.filter : "";
          // console.log(filter);
          return filterData.includes(notifiFilterSelection[0]);
        });
      }
    }

    if (!Array.isArray(_data) || !_data.length) {
      notifRow = <p className="text-center">{i18next.t('No recent activity to display')}</p>;
    } else {
      notifRow = _data.map((item, index) => {
        if (!notifHashMap[item.data.id]) {
          return (
						<NotificationRow
							{...this.props}
							value={item}
							keyVal={index}
							key={`notifications_${item.data.id}`}
							emojisData={this.state.emojisData}
						/>
          );
        }
      });
    }
    return (
		<FocusLock disabled={ this.state.isdisabled}>
			<div>
  {this.state.showNotificationWindow && (
					<div className="notification-left-wrapper col-md-4"
						id="notification-content-wrapper"
						tabIndex="-1"
					>
						<div
							role="dialog"
							aria-modal="true"
							aria-labelledby="notification-search-button-label"
						>
						<div className="wb-row notification-tray-header">
							<div className="col-md-9 no-padding">
								<div className="col-md-8" style={{ margin: 0, color: "white", fontSize: "1.6em" }}>
									<span role="heading" aria-level="1" id="notification-search-button-label">{i18next.t('Notifications')}</span>
									<span
										className=" icon icon-outline-search-18px-white"
										id="notification-search-button"
										onClick={this.toggleSearch.bind(this)}
										onKeyDown={(e) => KeyDownEvent(e, this.toggleSearch.bind(this))}
										style={{
										  position: "relative",
										  left: "8px",
										  top: "2px",
										  cursor: "pointer"
										}}
										role="button"
										tabIndex="0"
										aria-label={i18next.t('Search notifications')}
									/>
								</div>
								{!Array.isArray(_data) || !_data.length ? (
								  ""
								) : (
									<div
										className="col-md-4 text-right no-padding"
										style={{ marginTop: "7px" }}
									>
										<a
											onClick={this.deleteAll}
											onKeyDown={(e) => KeyDownEvent(e, this.deleteAll)}
											className="clickable"
											style={{ color: "white" }}
											role="button"
											tabIndex="0"
											aria-label={i18next.t('Remove all notifications')}
										>
											{i18next.t('Remove All')}
										</a>
									</div>
								)}
							</div>
							<div
								className="col-md-3 text-right no-padding"
								style={{ marginTop: "4px", minWidth: "68px" }}
							>
								{/*
									  <img
									  onClick={() => this.showMinimizedTray()}
									  src={wbConfig.baseUrl + "/images/minimize.png"}
									  width={16}
									  className={"clickable"}
									  />
									*/}

								<span
									className="icon icon-outline-filter_list-24px-white clickable filter-to-notification  "
									onClick={() => this.filteringToNotifications()}
									onKeyDown={(e) => KeyDownEvent(e, () => this.filteringToNotifications())}
									role="button"
									tabIndex="0"
									aria-label="Filter notifications"
								/>
								<span
									className="icon icon-outline-close-24px-white clickable hide-notification"
									onClick={() => this.hideNotificationWindow()}
									onKeyDown={(e) => KeyDownEvent(e, () => this.hideNotificationWindow())}
									role="button"
									tabIndex="0"
									aria-label={i18next.t('Close notifications')}
								/>
								{this.state.showFilter && (
									<div className="notification-dropdown">
										<div>
											<input
												id="filter1"
												onChange={e => this.applyFilter(e, 1)}
												type="checkbox"
												checked={
													!!(
													  this.state.notifiFilterSelection.length > 0 &&
														this.state.notifiFilterSelection.find(e => e == 1)
													)
												}
											/>
											<label htmlFor="filter1" className="notification-option">
											{i18next.t('All notifications')}
                        <span
													className={`icon ${this.state.notifiFilterSelection.length > 0 &&
														this.state.notifiFilterSelection.find(e => e == 1)
													  ? " icon-outline-check-24px-blue "
													  : " "
													}`}
												/>
											</label>
										</div>
										<div>
											<input
												id="filter2"
												onChange={e => this.applyFilter(e, 2)}
												type="checkbox"
												checked={
													!!(
													  this.state.notifiFilterSelection.length > 0 &&
														this.state.notifiFilterSelection.find(e => e == 2)
													)
												}
											/>
											<label htmlFor="filter2" className="notification-option">
												{(wbConfig.enableModules.execute ? i18next.t('Assigned to me &') + ' ' : '')}{i18next.t('my @mentions')}
                        <span
													className={`icon ${this.state.notifiFilterSelection.length > 0 &&
														this.state.notifiFilterSelection.find(e => e == 2)
													  ? " icon-outline-check-24px-blue "
													  : " "
													}`}
												/>
											</label>
										</div>
										<div>
											<input
												id="filter3"
												onChange={e => this.applyFilter(e, 3)}
												type="checkbox"
												checked={
													!!(
													  this.state.notifiFilterSelection.length > 0 &&
														this.state.notifiFilterSelection.find(e => e == 3)
													)
												}
											/>
											<label htmlFor="filter3" className="notification-option">
												{('OKR')} {i18next.t('notifications')}
                        <span
													className={`icon ${this.state.notifiFilterSelection.length > 0 &&
														this.state.notifiFilterSelection.find(e => e == 3)
													  ? " icon-outline-check-24px-blue "
													  : " "
													}`}
												/>
											</label>
										</div>
									</div>
								)}
							</div>
						</div>
						{this.state.notificationFiltter &&
							this.state.filterText != "" &&
							!this.state.showSearch && <div className="filter-icon" />}
						<div className="wb-row">
							{this.state.showSearch && (
								<input
									type="text"
									autoFocus
									value={this.state.searchString}
									ref="search"
									style={{
									  width: "92%",
									  margin: "10px 10px 10px 15px",
									  height: "29px",
									  fontSize: "16px",
									  borderRadius: "5px",
									  boxShadow: "0px 0px 2px 1px #52bad5",
									  border: "none",
									  padding: "0 5px",
									  boxSizing: "border-box"
									}}
									onChange={() => this.handleChange()}
									placeholder={i18next.t('Search')}
								/>
							)}
						</div>

						<div className="wb-row notification-applied-filter-row">
							{this.state.notificationFiltter && this.state.filterText != "" && (
								<React.Fragment>
									<div className="notification-applied-filter">
										<span className="showing-your-assigne">
											{this.state.filterText}
										</span>
									</div>
								</React.Fragment>
							)}
						</div>

						<div
						    data-testid = "notification-content-wrap"
							className={`wb-row notification-content-rows ${this.state.notificationFiltter && this.state.filterText != ""
							  ? ""
							  : "notification-content-rows-filter"
							}`}
						>
							{notifRow}
							{ isLoading ? (
								<div style={{ display: 'flex', margin: '30px 0px', justifyContent: 'center' }}>
									<Loader />
								</div>)
								: '' }
						</div>
						</div>
					</div>
				)}
				{this.state.showTray && (
					<NotificationTray
						showNotificationWindow={this.showNotificationWindow.bind(this)}
						isNew={this.state.isNew}
					/>
				)}
			</div>
		</FocusLock>
    );
  }
}

/**
 * Each row of the notifications.
 * @param: {data, index of the row}
 * @returns: the NotificationRow component
 * @class
 * @memberOf Notifications
 */
class NotificationRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.value || null,
      index: props.keyVal,
      selectedImage:
				(props.value.data.rag ? props.value.data.rag.rate : null) || null,
      showModal: false,
      modalProps: {}
    };
    this.deleteRow = this.deleteRow.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.updateReactedEmojis = this.updateReactedEmojis.bind(this);
    this.renderEmoji = this.renderEmoji.bind(this);
    this.GoalServices = new GoalServices();
  }

  updateReactedEmojis(data) {
    // console.log('updateReactedEmojis', data);
    this.props.actions.NotificationsReactionEmoji(data);
  }

  renderEmoji(data) {
    let isKRComment = ((data.action_type == 'Comment' || data.action_type == 'at_mention_goal') && data.object_type == 'goal' && typeof data.show_emoji !== 'undefined' && data.show_emoji);
    if (data.action_type == 'single_metric_updated'
			|| isKRComment) {
      let params = {};
      params.obj_type = 'kr_comment';
      params.obj_id = data.action_id;
      params.event_target_type = 'COMMENT';
      let showEmojiControl = false;
      if (data.action_type == 'single_metric_updated') {
        if (typeof data.emoji_data === 'undefined' || !Object.keys(data.emoji_data).length) {
          return null;
        }
        params.obj_type = data.emoji_data.obj_type;
        params.obj_id = data.emoji_data.obj_id;
        params.event_target_type = 'RESULT_UPDATE';
        if (typeof data.emoji_data.obj_owner !== 'undefined') {
          params.obj_owner = data.emoji_data.obj_owner;
        }
        if (typeof data.emoji_data.comment_id !== 'undefined') {
          params.event_target_type = 'RESULT_UPDATE_WITH_COMMENT';
        }
        if (typeof data.emoji_data.comment_only !== 'undefined') {
          params.event_target_type = 'RESULT_UPDATE_COMMENT_ONLY';
        }
        showEmojiControl = true;
      }
      if (isKRComment) {
        if (typeof data.metric_ds_data_id !== 'undefined' && data.metric_ds_data_id) {
          params.obj_type = 'kr_ds_value';
          params.obj_id = data.metric_ds_data_id;
          params.event_target_type = 'RESULT_UPDATE_WITH_COMMENT';
        }
        else if (typeof data.survey_data_id !== 'undefined' && data.survey_data_id) {
          params.obj_type = 'kr_survey_value';
          params.obj_id = data.survey_data_id;
          params.event_target_type = 'RESULT_UPDATE_WITH_COMMENT';
        }
        else if (typeof data.metric_data_id !== 'undefined' && data.metric_data_id) {
          params.obj_type = 'kr_data_value';
          params.obj_id = data.metric_data_id;
          params.event_target_type = 'RESULT_UPDATE_WITH_COMMENT';
        }
        else if (typeof data.metric_id !== 'undefined' && data.metric_id) {
          params.event_target_type = 'RESULT_UPDATE_COMMENT_ONLY';
        }
        showEmojiControl = true;
      }

      if (!showEmojiControl) {
        return null;
      }
      return <ReactionEmojiComp
				key={'reaction-emoji-comp-notification-' + data.action_type + '-' + data.id}
				wrapperClass='reaction-emoji-notification-wrapper'
				params={{
				  ...params,
				  event_type: 'notification',
				  goal_id: (data.goal_id !== "undefined" ) ? data.goal_id : data.object_id,
				  notificationData: data
				}}
				emojisData={this.props.emojisData}
				reacted_emojis={data.reacted_emojis}
				updateReactedEmojis={this.updateReactedEmojis}
			/>;
    }

  }

  /**
	 *
	 * @param {*} nextProps: When new data comes in from redux state
	 * @param {*} prevState: The previous state of the comp before update
	 */
  componentWillReceiveProps(nextProps, prevState) {
    this.setState({ data: nextProps.value });
  }

  /**
	 *
	 * @param {*} item: The notification item to delete
	 * @param {*} index: The index of the notification as it appears in the data list indexOf.
	 */
  deleteRow(item, index) {
    const { actions } = this.props
    const ids = [item.data.id]
    actions.NotificationsDeleteRow(ids, item)
  }

  /**
	 *
	 * @param {""} url
	 */
  showAiPopUp(url) {
    url = url.replace("ActionItemDetails", "aI");
    openFullPopUp(aiFullViewPopUp, url, this);
	this.props.closeModal();
    return false;
  }

  /**
	 *
	 * @param {""} id: Goal Id
	 */
  showGoalPopUp(id, metricId = null) {
    const params = { id };
    if (metricId) {
      return this.openKRPage(metricId);
    }
    if (
      (typeof params.id === "undefined" ||
				params.id == "" ||
				params.id == null) &&
			metricId
    ) {
      viewCascadeMetric(params.metricId);
    } else {
      viewGoalDetailsPage(undefined, params);
    }
  }

  openKRPage(metricId = null, type = '', inNewTab) {
    if (typeof inNewTab == 'undefined') {
      inNewTab = false;
    }
    if (metricId) {
      if (type == 'multiple_metric_updated') {
        viewGoalDetailsPage(undefined, { id: metricId });
      } else if (inNewTab == true) {
        var url = wbConfig.baseUrl + "/goal/krDetails?id=" + metricId
        window.open(url);
      } else {
        krDetailPage(metricId);
      }
    }
  }
  openMultiKrUpdate() {
    loadUpdateKrsPage();
    return false;
  }

  updateMetricData(thisVal) {
    const { data } = thisVal.state.data;
    const sliderHidInpId = `notUpdateKRMetDataId_${data.action_id}`;
    const metVal = $.trim($(`.${sliderHidInpId}`).val());
    if (metVal.length == 0) {
      return false;
    }

    // send the value to server
    const metricData = [];
    const metricDataId = [];
    const commentData = {};

    metricData.push(metVal);
    metricDataId.push(data.action_id);

    let surveyVal = 0;
    if (data.comment == 5) {
      surveyVal = 1;
    }
    showLoaderWidget($("#content"));
    const krSubmitUrl = `${wbConfig.baseUrl}/goal/metricDataSubmit`;

    $.post(
      krSubmitUrl,
      {
        metricId: data.object_id,
        metricGoalId: "",
        data: JSON.stringify(metricData),
        ids: JSON.stringify(metricDataId),
        comment: JSON.stringify(commentData),
        survey: surveyVal
      },
      retData => {
        retData = JSON.parse(retData);
        removeLoaderWidget();
        if (retData.success) {
          // delete that notification
          thisVal.deleteRow(thisVal.state.data, thisVal.state.index);
        }
      }
    );
  }

  displayDateTime(data) {
    const dateTime = data.modified_at > 0 ? data.modified_at * 1000 : data.created_at;
    let isIntgerFormat = false;
    if (data.modified_at > 0) {
      isIntgerFormat = true;
    }
    const user_timezone = data.user_timezone ? data.user_timezone : '';
    if ((typeof moment === "function") && dateTime && user_timezone) {
      let dateObj = isIntgerFormat ? moment(dateTime) : moment(moment(dateTime).format("YYYY-MM-DDTHH:mm:ss[Z]"));
      return dateObj.tz(user_timezone).format("MMMM Do YYYY [at] h:mm a");
    }
    return "N/A";
  }

  get notifContent() {
    const { t } = this.props;
    const { data } = this.state.data;
    let content;
    let url;
    const sliderHidInpId = `notUpdateKRMetDataId_${data.action_id}`;
    const datetime =
			(typeof moment === "function" &&
				data.user_timezone && data.created_at &&
				moment(moment(data.created_at).format("YYYY-MM-DDTHH:mm:ss[Z]"))
				  .tz(data.user_timezone)
				  .format("MMMM Do YYYY [at] h:mm a")) ||
			"N/A";
    const actionText = this.state.data.action_text;
    const actionDesc = this.state.data.action_desc;
    const deleTo = this.state.data.delegated_to;
    const deleTo_parsed = (this.state.data.delegated_to_parsed && this.state.data.delegated_to_parsed.value) ?
      this.state.data.delegated_to_parsed : null;
    //console.log(data,'data');

    if (data.object_type == 'reaction_emoji') {
      let content = `${data.user_name} ${actionText}`;
      const datetime1 = this.displayDateTime(data);
      if (data.action_type == 'kr_comment') {
        content = `${content} "${data.comment}" ${i18next.t('on the')} ${t('key result')} `;
      }
      return (
				<div
					className="col-md-12 clickable"
					style={{ paddingRight: "0" }}
				>
					{/* <div className="col-md-12 notif-title">{data.description ? data.description.replace(new RegExp("\\&nbsp;","g"),''): ''}</div> */}
					<div className="row">
						<div
							className="col-md-12 no-padding"
							style={{ margin: "5px 0 20px -2px", paddingRight: 0 }}
						>
							<span
								className="userProfileCover"
								style={{
								  background: `url(${data.user_pic}) no-repeat center center`,
								  backgroundSize: "cover"
								}}
							/>
							<div className="notification-content-wrapper">
								<div className="col-md-12" style={{ margin: "0" }}>
									<img
										className="notif-icon"
										src={`${wbConfig.baseUrl}/images/icons/notification/${this.state.data.icon}`}
									/>
									<span className="notif-gray">{datetime1}</span>
								</div>
								<span
									className="col-md-12 notif-content"
									data-testid="notif-content"
								>
									{
										(data.action_type == 'kr_comment') ?
											<React.Fragment>
												<span
													dangerouslySetInnerHTML={{ __html: content }}
												/>
												<span onClick={() => this.openKRPage(data.metric_id)}>
													<a>
														<span
															dangerouslySetInnerHTML={{ __html: data.metric_name }}
														/>
													</a>
												</span>
											</React.Fragment>
										  :
											<React.Fragment>
												<span
													dangerouslySetInnerHTML={{ __html: content }}
												/>
												<span onClick={() => this.openKRPage(data.object_id)}>
													<a>
														<span
															dangerouslySetInnerHTML={{ __html: actionDesc }}
														/>
													</a>
												</span>
											</React.Fragment>
									}
								</span>
							</div>
						</div>
					</div>
				</div>
      );
    }
    if (data.object_type == "goal") {
      if (data.action_type == "metric_update") {
        if (data.object_id == "0") {
          return (
						<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
							<div className="row">
								<div
									className="col-md-12 no-padding"
									style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
								>
									<span
										className="userProfileCover"
										style={{
										  background: `url(${data.user_pic}) no-repeat center center`,
										  backgroundSize: "cover"
										}}
									/>
									<div className="notification-content-wrapper">
										<div className="col-md-12" style={{ margin: "0" }}>
											<span
												className="icon icon-outline-update-24px"
												style={{ marginRight: "14px", marginBottom: "2px" }}
											>
												&nbsp;
                      						</span>
											<span className="notif-gray">{datetime}</span>
										</div>
										<span className="col-md-12 notif-content" data-testid="notif-content">
											<span dangerouslySetInnerHTML={{ __html: actionText }} />
											<span onClick={() => this.openMultiKrUpdate()}>
												<a>
													<span
														dangerouslySetInnerHTML={{ __html: actionDesc }}
													/>
												</a>
											</span>
										</span>
									</div>
								</div>
							</div>
						</div>
          );
        }
        return (
					<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
						<div className="row">
							<div
								className="col-md-12 no-padding"
								style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
							>
								<span
									className="userProfileCover"
									style={{
									  background: `url(${data.user_pic}) no-repeat center center`,
									  backgroundSize: "cover"
									}}
								/>
								<div className="notification-content-wrapper">
									<div className="col-md-12" style={{ margin: "0" }}>
										<span
											className="icon icon-outline-update-24px"
											style={{ marginRight: "14px", marginBottom: "2px" }}
										>
											&nbsp;
										</span>
										<span className="notif-gray">{datetime}</span>
									</div>
									<div className="col-md-12 notif-content" data-testid="notif-content">
										<span dangerouslySetInnerHTML={{ __html: actionText }} />
										<span
											onClick={() => this.showGoalPopUp(data.description_short, data.object_id)}
										>
											<a>
												<span
													dangerouslySetInnerHTML={{ __html: actionDesc }}
												/>
											</a>
										</span>
										<span dangerouslySetInnerHTML={{ __html: deleTo }} />
									</div>
									{(data.comment == 1 ||
										(data.comment == 5 &&
											data.aEncrypted != 6 &&
											data.aEncrypted != 5)) && (
											<div className="col-md-12 notInpArea">
												<input
													type="text"
													className={`gbl-text-entry notUpdTextarea ${sliderHidInpId}`}
                          id={`update_${sliderHidInpId}`}
													ref="met_upd_inp"
													placeholder={i18next.t('# update')}
                          onClick={() => document.getElementById(`update_${sliderHidInpId}`).focus()}
												/>
												<button
													className="gbl-btn gbl-btn-slim notUpdBtn"
													onClick={() => this.updateMetricData(this)}
												>
													{i18next.t('Update')}
                      							</button>
											</div>
									)}
									{data.comment == 5 && data.aEncrypted == 6 && (
										<SurveyScale
											metricDataId={data.action_id}
											metricId={data.object_id}
											upper_limit={data.to}
											lower_limit={data.cEncrypted}
											dispDate={data.rag}
											val={data.file_name}
											updateMetricData={this.updateMetricData}
											parentObj={this}
										/>
									)}
									{data.comment == 5 && data.aEncrypted == 5 && (
										<SurveyYesNo
											metricDataId={data.action_id}
											metricId={data.object_id}
											updateMetricData={this.updateMetricData}
											parentObj={this}
										/>
									)}
								</div>
							</div>
						</div>
					</div>
        );
      } else if (
        data.action_type == "single_metric_updated" ||
				data.action_type == "multiple_metric_updated"
      ) {
        //console.log(data);
        if (data.from != "" && data.action_type == "multiple_metric_updated") {
          data.object_id = data.from;
          data.action_type = 'single_metric_updated';
        }
        const actText = `${data.user_name} ${actionText}`;
		console.log('actText',actText);
		console.log('actionDesc',actionDesc);
        return (
					<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
						<div className="row">
							<div
								className="col-md-12 no-padding"
								style={{ margin: "5px 0 20px -2px", paddingRight: 0 }}
							>
								<span
									className="userProfileCover"
									style={{
									  background: `url(${data.user_pic}) no-repeat center center`,
									  backgroundSize: "cover"
									}}
								/>
								<div className="notification-content-wrapper">
									<div className="col-md-12" style={{ margin: "0" }}>
										<span
											className="icon icon-KR-18px"
											style={{ marginRight: "15px", marginBottom: "2px" }}
										>
											&nbsp;
                    					</span>
										<span className="notif-gray">{datetime}</span>
									</div>
									<span className="col-md-12 notif-content" data-testid="notif-content">
										<span dangerouslySetInnerHTML={{ __html: actText }} />
										<span
											onClick={() =>
											  this.openKRPage(
											    data.object_id, data.action_type
											  )
											}
										>
											<a>
												<span
													dangerouslySetInnerHTML={{ __html: actionDesc }}
												/>
											</a>
										</span>
										{
											(deleTo_parsed) ?
												<React.Fragment>
													<span dangerouslySetInnerHTML={{ __html: deleTo_parsed.pre_str }} />
													<span style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: deleTo_parsed.value }} />
													<span dangerouslySetInnerHTML={{ __html: deleTo_parsed.post_str }} />
												</React.Fragment>
											  :
												<span dangerouslySetInnerHTML={{ __html: deleTo }} />
										}
										{
											(data.achieve_target) &&
											<span>
												<span className="dotClass"></span>
												<span>{i18next.t('Current progress') +':'} </span>
												<span
													style={{ color: (data.progress_color ? data.progress_color : '#55BAD5') }}
													dangerouslySetInnerHTML={{ __html: data.achieve_target }}>
												</span>
												{
													(data.target_display) &&
													<span>
														{' '}
														{i18next.t('of')}
																{' '}
														{data.target}
														{' '}
													</span>
												}
											</span>
										}
										{this.renderEmoji(data)}
									</span>
								</div>
							</div>
						</div>
					</div>
        );
      } else if (data.action_type == "kr_notification") {
        const actText = `${actionText}`;
        return (
					<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
						<div className="row">
							<div
								className="col-md-12 no-padding"
								style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
							>
								<span
									className="userProfileCover"
									style={{
									  background: `url(${data.user_pic}) no-repeat center center`,
									  backgroundSize: "cover"
									}}
								/>
								<div className="notification-content-wrapper">
									<div className="col-md-12" style={{ margin: "0" }}>
										<span
											className="icon icon-KR-18px"
											style={{ marginRight: "15px", marginBottom: "2px" }}
										>
											&nbsp;
                    					</span>
										<span className="notif-gray">{datetime}</span>
									</div>
									<span className="col-md-12 notif-content" data-testid="notif-content">
										<span
											onClick={() =>
											  this.showGoalPopUp(
											    data.description_short,
											    data.object_id
											  )
											}
										>
											<a>
												<span
													dangerouslySetInnerHTML={{ __html: data.fromMetric }}
												/>
											</a>
										</span>
										<span dangerouslySetInnerHTML={{ __html: ` ${actText}` }} />
										<span
											onClick={() =>
											  this.showGoalPopUp(
											    data.description_short,
											    data.object_id
											  )
											}
										>
											<a>
												<span
													dangerouslySetInnerHTML={{ __html: ` ${actionDesc}` }}
												/>
											</a>
										</span>
										<span dangerouslySetInnerHTML={{ __html: ` ${deleTo}` }} />
									</span>
								</div>
							</div>
						</div>
					</div>
        );
      } else if (data.action_type == "goal_comment_list") {
        if (data.description) {
          data.description = data.description.trim();
        }
        content = `${data.user_name} <a href="javascript:void(0)">${this.state.data.action_text}</a> ${data.description} <a href="javascript:void(0)">${actionDesc}</a> ${deleTo}`;
        return (
					<div
						className="col-md-12 clickable"
						style={{ paddingRight: "0" }}
						onClick={() => this.showGoalPopUp(data.object_id)}
					>
						<div className="row">
							<div
								className="col-md-12 no-padding"
								style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
							>
								<span
									className="userProfileCover"
									style={{
									  background: `url(${data.user_pic}) no-repeat center center`,
									  backgroundSize: "cover"
									}}
								/>
								<div className="notification-content-wrapper">
									<div className="col-md-12" style={{ margin: "0" }}>
										<img
											className="notif-icon"
											src={`${wbConfig.baseUrl}/images/icons/notification/${this.state.data.icon}`}
										/>
										<span className="notif-gray">{datetime}</span>
									</div>
									<span
										className="col-md-12 notif-content"
										data-testid="notif-content"
										dangerouslySetInnerHTML={{ __html: content }}
									/>
								</div>
							</div>
						</div>
					</div>
        );
      } else if (data.action_type == "metric_cascade") {
        const actText = `${data.user_name} ${actionText}`;
        return (
					<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
						<div className="row">
							<div
								className="col-md-12 no-padding"
								style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
							>
								<span
									className="userProfileCover"
									style={{
									  background: `url(${data.user_pic}) no-repeat center center`,
									  backgroundSize: "cover"
									}}
								/>
								<div className="notification-content-wrapper" data-testid="notification-content-wrapper">
									<span onClick={() => this.handleOpenModal(data)}>
										<div className="col-md-12" style={{ margin: "0" }}>
											{/* replacing icon path supplied by PHP with the newer sprite icon from current/refreshed spec */}
											<span
												className="icon icon-KR-18px"
												style={{ marginRight: "15px", marginBottom: "2px" }}
											>
												&nbsp;
                      						</span>
											<span className="notif-gray">{datetime}</span>
										</div>
										<span className="col-md-12 notif-content" data-testid="notif-content">
											<span dangerouslySetInnerHTML={{ __html: actText }} />
											<a>
												<span
													dangerouslySetInnerHTML={{ __html: actionDesc }}
												/>
											</a>
											<span dangerouslySetInnerHTML={{ __html: deleTo }} />
										</span>
									</span>
								</div>
							</div>
						</div>
					</div>
        );
      } else if ((data.object_type == "goal" && data.action_type == "delegate") ||
				(data.object_type == "goal" && data.action_type == "metric_real_owner") ) {
        const actText = `${data.user_name} ${actionText}`;
        return (
					<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
						<div className="row">
							<div
								className="col-md-12 no-padding"
								style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
							>
								<span
									className="userProfileCover"
									style={{
									  background: `url(${data.user_pic}) no-repeat center center`,
									  backgroundSize: "cover"
									}}
								/>
								<div className="notification-content-wrapper">
									<div className="col-md-12" style={{ margin: "0" }}>
										<span
											className="icon icon-KR-18px"
											style={{ marginRight: "15px", marginBottom: "2px" }}
										>
											&nbsp;
                    					</span>
										<span className="notif-gray">{datetime}</span>
									</div>
									<span className="col-md-12 notif-content" data-testid="notif-content">
										<span dangerouslySetInnerHTML={{ __html: actText }} />
										<span
											onClick={() =>
											  this.showGoalPopUp(data.object_id, data.action_id)
											}
										>
											<a>
												<span>
													{actionDesc}
												</span>
											</a>
										</span>
										<span dangerouslySetInnerHTML={{ __html: deleTo }} />
									</span>
								</div>
							</div>
						</div>
					</div>
        );
      } else if (data.action_type == "KrAttachmentAdd" || data.action_type == "KrAttachmentDel") {
        const actText = `${data.user_name} ${actionText}`;
        return (
					<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
						<div className="row">
							<div
								className="col-md-12 no-padding"
								style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
							>
								<span
									className="userProfileCover"
									style={{
									  background: `url(${data.user_pic}) no-repeat center center`,
									  backgroundSize: "cover"
									}}
								/>
								<div className="notification-content-wrapper">
									<span onClick={() => this.handleKrAttachment(data.object_id)}>
										<div className="col-md-12" style={{ margin: "0" }}>
											{/* replacing icon path supplied by PHP with the newer sprite icon from current/refreshed spec */}
											<img
												className="notif-icon"
												src={`${wbConfig.baseUrl}/images/icons/notification/${this.state.data.icon}`}
											/>
											<span className="notif-gray">{datetime}</span>
										</div>
										<span className="col-md-12 notif-content" data-testid="notif-content">
											<span dangerouslySetInnerHTML={{ __html: actText }} />
											<a>
												<span
													dangerouslySetInnerHTML={{ __html: actionDesc }}
												/>
											</a>
											<span dangerouslySetInnerHTML={{ __html: deleTo }} />
										</span>
									</span>
								</div>
							</div>
						</div>
					</div>
        );
      } else if (data.action_type == "MetricDependenciesAdd" || data.action_type == "MetricDependenciesDel") {
        content = `${data.user_name} ${this.state.data.action_text} <a>${data.description}</a> ${this.state.data.delegated_to}`;
        return (
					<div
						className="col-md-12 clickable"
						style={{ paddingRight: "0" }}
					>
						{/* <div className="col-md-12 notif-title">{data.description ? data.description.replace(new RegExp("\\&nbsp;","g"),''): ''}</div> */}
						<div className="row">
							<div
								className="col-md-12 no-padding"
								style={{ margin: "5px 0 20px -2px", paddingRight: 0 }}
							>
								<span
									className="userProfileCover"
									style={{
									  background: `url(${data.user_pic}) no-repeat center center`,
									  backgroundSize: "cover"
									}}
								/>
								{/*
                <img
                  className="roundFramePhoto userProfPic userProfilePicWid"
                  src={data.user_pic}
                  width={40}
                  height={40}
                /> */}
								<div className="notification-content-wrapper">
									<div className="col-md-12" style={{ margin: "0" }}>
										<span
											className="icon icon-KR-18px"
											style={{ marginRight: "15px", marginBottom: "2px" }}
										>&nbsp;
                    					</span>
										<span className="notif-gray">{datetime}</span>
									</div>
									<span
										className="col-md-12 notif-content 1325"
										data-testid="notif-content"
									>
										<span
											// onClick={() => this.showGoalPopUp(data.object_id, data.krId)}
											onClick={() => this.handleKRComment(data.krId)}
											dangerouslySetInnerHTML={{ __html: content }}
										/>
										{this.renderEmoji(data)}
									</span>
								</div>
							</div>
						</div>
					</div>
        );
      }
      else if (data.action_type == "kr_owner_delete_kr") {
        const actText = `${data.user_name} ${actionText}`;
        content = `${this.state.data.delegated_to}`;
        return (
					<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
						<div className="row">
							<div
								className="col-md-12 no-padding"
								style={{ margin: "5px 0 20px -2px", paddingRight: 0 }}
							>
								<span
									className="userProfileCover"
									style={{
									  background: `url(${data.user_pic}) no-repeat center center`,
									  backgroundSize: "cover"
									}}
								/>
								<div className="notification-content-wrapper">
									<div className="col-md-12" style={{ margin: "0" }}>
										<span
											className="icon icon-KR-18px"
											style={{ marginRight: "15px", marginBottom: "2px" }}
										>
											&nbsp;
                    					</span>
										<span className="notif-gray">{datetime}</span>
									</div>
									<span className="col-md-12 notif-content" data-testid="notif-content">
										<span dangerouslySetInnerHTML={{ __html: actText }} />
										<span style={{ fontWeight: "bold" }} dangerouslySetInnerHTML={{ __html: actionDesc }} />
									</span>
									<span className="col-md-12 notif-content" data-testid="notif-content">
										<span className="notif-keyresult-deatils"
											dangerouslySetInnerHTML={{ __html: content }}
										/>
									</span>
								</div>
							</div>
						</div>
					</div>
        );
      }
      else if (data.action_type == "kr_owner_change_consider") {
        const actText = `${data.user_name} excluded the ${t('key result')}`;
        const content = ` from ${t('objective')} progress calculation `;
        return (
					<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
						<div className="row">
							<div
								className="col-md-12 no-padding"
								style={{ margin: "5px 0 20px -2px", paddingRight: 0 }}
							>
								<span
									className="userProfileCover"
									style={{
									  background: `url(${data.user_pic}) no-repeat center center`,
									  backgroundSize: "cover"
									}}
								/>
								<div className="notification-content-wrapper">
									<div className="col-md-12" style={{ margin: "0" }}>
										<span
											className="icon icon-KR-18px"
											style={{ marginRight: "15px", marginBottom: "2px" }}
										>
											&nbsp;
                    					</span>
										<span className="notif-gray">{datetime}</span>
									</div>
									<span className="col-md-12 notif-content" data-testid="notif-content">
										<span dangerouslySetInnerHTML={{ __html: actText }} />
										<span
											onClick={() =>
											  this.openKRPage(
											    data.action_id, data.action_type, true
											  )
											}
										>
											<a>
												<span
													dangerouslySetInnerHTML={{ __html: actionDesc }}
												/>
											</a>
										</span>
										<span dangerouslySetInnerHTML={{ __html: content }} />
										<span className="notif-content" style={{ display: "table" }}>
											<span className="notif-keyresult-deatils" dangerouslySetInnerHTML={{ __html: deleTo }} />
										</span>
									</span>
								</div>
							</div>
						</div>
					</div>
        );
      }
      else if (data.action_type == "kr_owner_change_target" || data.action_type == "kr_owner_change_source") {
        const actText = `${data.user_name} ${actionText}`;
        return (
					<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
						<div className="row">
							<div
								className="col-md-12 no-padding"
								style={{ margin: "5px 0 20px -2px", paddingRight: 0 }}
							>
								<span
									className="userProfileCover"
									style={{
									  background: `url(${data.user_pic}) no-repeat center center`,
									  backgroundSize: "cover"
									}}
								/>
								<div className="notification-content-wrapper">
									<div className="col-md-12" style={{ margin: "0" }}>
										<span
											className="icon icon-KR-18px"
											style={{ marginRight: "15px", marginBottom: "2px" }}
										>
											&nbsp;
                    					</span>
										<span className="notif-gray">{datetime}</span>
									</div>
									<span className="col-md-12 notif-content" data-testid="notif-content">
										<span dangerouslySetInnerHTML={{ __html: actText }} />
										<span
											onClick={() =>
											  this.openKRPage(
											    data.action_id, data.action_type, true
											  )
											}
										>
											<a>
												<span
													dangerouslySetInnerHTML={{ __html: actionDesc }}
												/>
											</a>
										</span>
										<span dangerouslySetInnerHTML={{ __html: deleTo }} />
									</span>
								</div>
							</div>
						</div>
					</div>
        );
      }
      else if (data.action_type == "confidence_set" || data.action_type == "confidence_removed") {
        const actText = `${data.user_name} ${actionText}`;
        const from = JSON.parse(`${data.from}`);
        const flagComment = `${from.comment}`;
        const achiveTarget = `${from.achieve_target}`;
        const totalTarget = from?.total_target ? ' ' + i18next.t('of') + ' ' + from.total_target : "";
        const progress = `<span style="color: ${from.progress_color} "> ${achiveTarget}</span>${totalTarget}`;
        const confClass = data.to == 1 ? "confidenceIcon-Low" : data.to == 2 ? "confidenceIcon-Medium" : data.to == 3 ? "confidenceIcon-High" : "confidenceIcon-Default";
        return (
					<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
						<div className="row">
							<div
								className="col-md-12 no-padding"
								style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
							>
								<span
									className="userProfileCover"
									style={{
									  background: `url(${data.user_pic}) no-repeat center center`,
									  backgroundSize: "cover"
									}}
								/>
								<div className="notification-content-wrapper">
									<div className="col-md-12" style={{ margin: "0" }}>
										<span
											className="icon icon-KR-18px"
											style={{ marginRight: "15px", marginBottom: "2px" }}
										>
											&nbsp;
                    					</span>
										<span className="notif-gray">{datetime}</span>
									</div>
									<div className="col-md-12 notif-content" data-testid="notif-content">
										<span dangerouslySetInnerHTML={{ __html: actText }} />
										<span
											onClick={() =>
											  this.showGoalPopUp(data.object_id, data.action_id)
											}
										>
											<a>
												<span
													dangerouslySetInnerHTML={{ __html: actionDesc }}
												/>
											</a>
										</span>
										{data.to != null && <span dangerouslySetInnerHTML={{ __html: deleTo }} />}
										{
											(data.to != null && from.from != data.to) &&
												<>
													<div className={"confidenceIcon krRow " + confClass} style={{ width: '12px', marginLeft: '5px', height: '12px', display: "inline-block", marginBottom: '-2px' }}>
													</div>
													<div className="dotClass"></div>
												</>

										}
										{
											(!data.to) &&
												<div className="dotClass"></div>
										}
										<span>{i18next.t('Current progress') + ':'}</span>
										<span dangerouslySetInnerHTML={{ __html: progress }} />
										<div>
											{i18next.t('With this comment') + ':'}
											<div dangerouslySetInnerHTML={{ __html: flagComment }} />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
        );
      }
	  else if (data.action_type == "metric_committed_target") {
		const actText = `${data.user_name} ${actionText}`;
		return (
			<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
				<div className="row">
				<div
					className="col-md-12 no-padding"
					style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
				>
					<span
						className="userProfileCover"
						style={{
							background: `url(${data.user_pic}) no-repeat center center`,
							backgroundSize: "cover"
						}}
					/>
					<div className="notification-content-wrapper">
						<div className="col-md-12" style={{ margin: "0" }}>
							<span
								className="icon icon-KR-18px"
								style={{ marginRight: "15px", marginBottom: "2px" }}
							>
								&nbsp;
							</span>
							<span className="notif-gray">{datetime}</span>
						</div>
						<span className="col-md-12 notif-content" data-testid="notif-content">
							<span dangerouslySetInnerHTML={{ __html: actText }} />
							<span
								onClick={() =>
									this.showGoalPopUp(data.object_id, data.action_id)
								}
							>
								<a>
									<span
										dangerouslySetInnerHTML={{ __html: actionDesc }}
									/>
								</a>
							</span>
							<span dangerouslySetInnerHTML={{ __html: deleTo }} />
						</span>
						<div className="col-md-12" style={{ margin: "0", paddingRight: '0' }}>
							<span>{i18next.t('Current progress') + ':'} </span>
							<span
								style={{ color: (data.progress_color ? data.progress_color : '#55BAD5') }}
								dangerouslySetInnerHTML={{ __html: data.achieve_target }}>
							</span>
							{
								(data.target_display) &&
								<span>
									{' '}
									{i18next.t('of')}
											{' '}
									{data.target}
									{' '}
								</span>
							}
							<span>, {i18next.t('Result Owner') + ':'} </span>
							<span>{data.realOwner}</span>
							<span>, {i18next.t('Data Source') + ':'} </span>
							<span dangerouslySetInnerHTML={{ __html: data.source }}></span>
						</div>
					</div>
				</div>
			</div>
		</div>
		);
	  }
      const comment = data.comment
        ? data.action_type == "at_mention" ||
					data.action_type == "Comment" ||
					data.action_type == "at_mention_goal"
          ? `"${data.comment}"`
          : data.comment
        : "";
      if (data.description) {
        data.description = data.description.trim();
      }
      let metricId = '';
      if ((typeof data.krId !== 'undefined' && data.krId && data.action_type == "at_mention_goal")) {
        metricId = data.krId;
      }
      else if ((data.action_type == 'Comment' && data.object_type == 'goal' && typeof data.show_emoji !== 'undefined' && data.show_emoji)) {
        metricId = data.metric_id;
      }
      let krMentionId = (typeof data.krId !== 'undefined' && data.krId && data.action_type == "at_mention_goal") ? ' ' + i18next.t('and commented') + ' ' : '';
      content = `${data.user_name} ${this.state.data.action_text} <a href="javascript:void(0)">${data.description}</a> ${krMentionId} ${comment}`;
      return (
				<div
					className="col-md-12 clickable"
					style={{ paddingRight: "0" }}
				>
					{/* <div className="col-md-12 notif-title">{data.description ? data.description.replace(new RegExp("\\&nbsp;","g"),''): ''}</div> */}
					<div className="row">
						<div
							className="col-md-12 no-padding"
							style={{ margin: "5px 0 20px -2px", paddingRight: 0 }}
						>
							<span
								className="userProfileCover"
								style={{
								  background: `url(${data.user_pic}) no-repeat center center`,
								  backgroundSize: "cover"
								}}
							/>
							{/*
                <img
                  className="roundFramePhoto userProfPic userProfilePicWid"
                  src={data.user_pic}
                  width={40}
                  height={40}
                /> */}
							<div className="notification-content-wrapper">
								<div className="col-md-12" style={{ margin: "0" }}>
									<img
										className="notif-icon"
										src={`${wbConfig.baseUrl}/images/icons/notification/${this.state.data.icon}`}
									/>
									<span className="notif-gray">{datetime}</span>
								</div>
								<span
									className="col-md-12 notif-content"
									data-testid="notif-content"
								>
									<span
										onClick={() => this.showGoalPopUp(data.object_id, metricId)}
										dangerouslySetInnerHTML={{ __html: content }}
									/>
									{this.renderEmoji(data)}
								</span>
							</div>
						</div>
					</div>
				</div>
      );
    }
    if (data.object_type == "activity") {
      url = `${wbConfig.baseUrl}/activity/ActionItemDetails?id=${data.object_id}`;
      if (data.action_type == "Due date") {
        content = `${data.user_name} ${this.state.data.action_text} <a href="javascript:void(0)" data-href="${wbConfig.baseUrl}/activity/ActionItemDetails?id=${data.object_id}">${data.description}</a> ${this.state.data.action_desc}`;
      } else if (data.action_type == "reminder") {
        content = `${data.user_name} ${this.state.data.action_text} <a href="javascript:void(0)" data-href="${wbConfig.baseUrl}/activity/ActionItemDetails?id=${data.object_id}">${data.description}</a> <br/>${this.state.data.action_desc}`;
      } else if (data.action_type == "board_column_notify") {
        content = `${data.user_name} ${i18next.t('added')} <a>${this.state.data.action_text}</a> ${this.state.data.action_desc} <a>${this.state.data.delegated_to}</a> ${i18next.t('board')}`;
      } else if (data.action_type == "board_column_change") {
        content = `${data.user_name} ${this.state.data.action_desc} <a href="javascript:void(0)"  data-href="${wbConfig.baseUrl}/activity/ActionItemDetails?id=${data.object_id}">${data.description}</a> ${this.state.data.action_text}  `;
      } else {
        const comment = data.comment
          ? data.action_type == "at_mention" || data.action_type == "Comment"
            ? `"${data.comment}"`
            : data.comment
          : "";
        content = `${data.user_name} ${this.state.data.action_text} <a href="javascript:void(0)"  data-href="${wbConfig.baseUrl}/activity/ActionItemDetails?id=${data.object_id}">${data.description}</a> ${comment}`;
      }
      return (
				<div
					className="col-md-12 clickable"
					style={{ paddingRight: "0" }}
					onClick={() => this.showAiPopUp(url)}
				>
					{/* <div className="col-md-12 notif-title">{data.description ? data.description.replace(new RegExp("\\&nbsp;","g"),''): ''}</div> */}
					<div className="row">
						<div
							className="col-md-12 no-padding"
							style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
						>
							<span
								className="userProfileCover"
								style={{
								  background: `url(${data.user_pic}) no-repeat center center`,
								  backgroundSize: "cover"
								}}
							/>
							{/*
              <img
                className="roundFramePhoto userProfPic userProfilePicWid"
                src={data.user_pic}
                width={40}
                height={40}
              /> */}
							{/* <span className="col-md-10" onClick={() => this.getAiDetails(wbConfig.baseUrl + `/activity/ActionItemDetails?id=${data.object_id}`)} dangerouslySetInnerHTML={{__html: content}}></span> */}
							<div className="notification-content-wrapper">
								<div className="col-md-12" style={{ margin: "0" }}>
									{
										data?.iconComponentName ?
										<IconWrapper>
											<Icon name={data.iconComponentName} width="16" height="16" />
										</IconWrapper>
										: <img
										className="notif-icon"
										src={`${wbConfig.baseUrl}/images/icons/notification/${this.state.data.icon}`}
									/>
									}
									<span className="notif-gray">{datetime}</span>
								</div>
								<span
									className="col-md-12 notif-content"
									data-testid="notif-content"
									data-keyval={this.props.keyVal}
									dangerouslySetInnerHTML={{ __html: content }}
								/>
							</div>
						</div>
					</div>
				</div>
      );
    }
	if ( (data.object_type == "rollup_okr" || data.object_type == "rollup_kr" || data.object_type == "mirrored_kr" || data.object_type == "cascade_kr") && ( data.action_type == "rollupnewkr" || data.action_type == "removedrollup" || data.action_type == "addedMirroredKR" || data.action_type == "deleteMirroredKR" || data.action_type == "deleteCascadeChildKR" || data.action_type == "cascadeAcceptance") ){
		const actText = `${actionText}`;
		return (
			<div className="col-md-12 clickable" style={{ paddingRight: "0" }}>
				<div className="row">
				<div
					className="col-md-12 no-padding"
					style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
				>
					<span
						className="userProfileCover"
						style={{
							background: `url(${data.user_pic}) no-repeat center center`,
							backgroundSize: "cover"
						}}
					/>
					<div className="notification-content-wrapper">
						<div className="col-md-12" style={{ margin: "0" }}>
							<span
								className="icon icon-KR-18px 1"
								style={{ marginRight: "15px", marginBottom: "2px" }}
							>
								&nbsp;
							</span>
							<span className="notif-gray">{datetime}</span>
						</div>
						<span className="col-md-12 notif-content" data-testid="notif-content">
							<span dangerouslySetInnerHTML={{ __html: actText }} />
							{
								( data.object_type == "rollup_okr" && ( data.action_type == "removedrollup" || data.action_type == "rollupnewkr" )) &&
								<a><span onClick={() => this.showGoalPopUp(data.object_id)} dangerouslySetInnerHTML={{ __html:data.name }}/></a>
							}
							<span dangerouslySetInnerHTML={{ __html: actionDesc }} />
							<span dangerouslySetInnerHTML={{ __html: deleTo }} />
						</span>
					</div>
				</div>
			</div>
		</div>
		);
	}
	if (data.object_type == "kpi") {
		const actText = `${data.user_name} ${actionText}`;
		const handleKpiClick = () => data.url && window.open(data.url, "_self");
		return (
			<div
				className="col-md-12 clickable"
				style={{ paddingRight: "0" }}
				onClick={handleKpiClick}
				onKeyDown={(e) => KeyDownEvent(e, handleKpiClick)}
				role="button"
				tabIndex="0"
			>
				<div className="row">
					<div
						className="col-md-12 no-padding"
						style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
					>
						<span
							className="userProfileCover"
							style={{
								background: `url(${data.user_pic}) no-repeat center center`,
								backgroundSize: "cover"
							}}
						/>
						<div className="notification-content-wrapper">
							<div className="col-md-12" style={{ margin: "0" }}>
								<img
									className="notif-icon"
									src={`${wbConfig.baseUrl}/images/icons/notification/${this.state.data.icon}`}
									alt=""
								/>
								<span className="notif-gray">{datetime}</span>
							</div>
							<span className="col-md-12 notif-content" data-testid="notif-content">
								<span dangerouslySetInnerHTML={{ __html: actText }} />
								{actionDesc && (
									<span>
										{' '}
										<a>
											<span dangerouslySetInnerHTML={{ __html: actionDesc }} />
										</a>
									</span>
								)}
								{deleTo && <span dangerouslySetInnerHTML={{ __html: ` ${deleTo}` }} />}
							</span>
						</div>
					</div>
				</div>
			</div>
		);
	}
    return (
			<div
				className="col-md-12 clickable"
				style={{ paddingRight: "0" }}
				onClick={() => window.open(data.url, "_self")}
			>
				{/* <div className="col-md-12 notif-title">{data.description ? data.description.replace(new RegExp("\\&nbsp;","g"),''): ''}</div> */}
				<div className="row">
					<div
						className="col-md-12 no-padding"
						style={{ margin: "5px 0 5px -2px", paddingRight: 0 }}
					>
						<span
							className="userProfileCover"
							style={{
							  background: `url(${data.user_pic}) no-repeat center center`,
							  backgroundSize: "cover"
							}}
						/>
						{/*
              <img
                className="roundFramePhoto userProfPic userProfilePicWid"
                src={data.user_pic}
                width={40}
                height={40}
              /> */}
						<div className="notification-content-wrapper">
							<div className="col-md-12" style={{ margin: "0" }}>
								<img
									className="notif-icon"
									src={`${wbConfig.baseUrl}/images/icons/notification/${this.state.data.icon}`}
								/>
								<span className="notif-gray">{datetime}</span>
							</div>
							<span
								className="col-md-10 notif-content"
								dangerouslySetInnerHTML={{
								  __html: this.state.data.action_text
								}}
							/>
						</div>
					</div>
				</div>
			</div>
    );
  }
	handleKrAttachment = (metricId) => {
	  krDetailPage(metricId);
	}
	handleKRComment = (metricId) => {
	  krDetailPage(metricId);
	}
	handleOpenModal(item) {
		const isCascadeMetric = item && typeof item.action_type !== 'undefined' && item.action_type === 'metric_cascade'
	  let _this = this;
	  reactLoader();
	  let url = undefined;
	  if (!isCascadeMetric) {
	    url = `${wbConfig.baseUrl}/goal/index?fromNotification=1`;
	  }
	  ajaxPageLoad(
	    url,
	    undefined,
	    undefined,
	    undefined,
	    undefined,
	    function () {
	      removeLoader();
	      removeReactLoader();
	      let params = {};
	      params.metricId = item.action_id;
	      if (item.to && item.to.length > 0) {
	        params.metricId = item.to;
	        params.cascadeReq = true;
	      }
	      _this.GoalServices.createCascadeDetails(params)
	        .then(response => {
	          let url = "";
	          if (!isCascadeMetric) {
	            url = `${wbConfig.baseUrl}/goal/index`;
	          }

						if(url) {
							window.history.pushState("", "", url);
							activeTopMenuId("objectives");
						}
	          removeLoader();
	          removeReactLoader();
	          if (response.data) {
	            _this.setState(
	              { showModal: true, modalProps: response.data.data },
	              () => {
	                // PageScrollVisible();
	                var e = document.querySelector("body");
	                if (e) {
	                  e.style.overflow = "hidden";
	                }
	                setTimeout(() => SetKrContainerHeight(), 0);
	              }
	            );
	          }
	        })
	        .catch(function (error) {
	          if (error.response) {
	            removeReactLoader();
	          }
	        });
	    },
	    "true"
	  );
	}

	handleCloseModal() {
	  this.setState({ showModal: false }, () => {
	    // PageScrollVisible(true);
	    var e = document.querySelector("body");
	    if (e) {
	      e.style.overflow = "visible";
	    }
	  });
	}

	render() {
	  // console.log(this.state.showModal);

	  return (
			<div className="col-md-12 no-padding">
				<div
					className={`${this.state.data.data.is_seen == "1" ? "" : "unread-notification"
					} notification-row`}
					tabIndex="0"
				>
					{"parentOrgRole" in this.state.data.data &&
						this.state.data.data.parentOrgRole == "1" ? (
							<div
								className="hint--right"
								style={{
								  width: "24px",
								  height: "24px",
								  position: "absolute",
								  top: 0,
								  zIndex: 1000
								}}
								data-hint="From your manager"
							>
								<div className="unseen" />
							</div>
					  ) : (
					    ""
					  )}
					{this.notifContent}

					<KrModal
						isOpen={this.state.showModal}
						handleCloseModal={this.handleCloseModal}
						data={this.state.modalProps}
						showRealOwner={this.state.modalProps.show_real_owner}
					/>

					<div className="notification-row-delete wb-hide text-right">
						<img
							onClick={() => this.deleteRow(this.state.data, this.state.index)}
							src={`${wbConfig.baseUrl}/images/notification_close.png`}
							width={16}
							className="clickable notif-delete"
							role="button"
							tabIndex="0"
							aria-label={i18next.t('Delete this notification')}
						/>
					</div>
				</div>
			</div>
	  );
	}
}

const SurveyScale = (props) => {
  const minValue = props.lower_limit || 0;
  const maxValue = props.upper_limit ? parseInt(props.upper_limit.split('-')[1]) : 0;
  const v = props.val ? props.val : minValue;
  const [value, setValue] = useState(v);
  const onChangeRange = (e, val) => {
    setValue(val);
  }
  return (
		<div className="updateKRWrapper notUpdateKR">
			<div className="displayInlineB updateKRSliderData">
				<div className="displayInlineB updateKRMinMaxVal" style={{width: '85%'}}>
					<ScaleRange
						value={value}
						handleChange={onChangeRange}
						min={minValue}
            max={maxValue}
            showMinMax={true}
					/>
          <input type="hidden" className={`notUpdateKRMetDataId_${props.metricDataId}`} value={value} />
				</div>
			</div>
			<div className="displayInlineB notSlideUpdateBtn">
				<button
					className="gbl-btn gbl-btn-slim notUpdBtn "
					onClick={() => props.updateMetricData(props.parentObj)}
				>
					{i18next.t('Update')}
				</button>
			</div>
		</div>
  );
}

const SurveyYesNo = (props) => {
  const mdId = props.metricDataId;
  const surveyHidInpId = `notUpdateKRMetDataId_${mdId}`;
  const [surveyValue, setSuveryValue] = useState(0);
  const btnClicked = (selVal) => {
    document.getElementById(`survey_${surveyHidInpId}`).value(selVal);
    setSuveryValue(selVal);
    props.updateMetricData(props.parentObj);
  }
  const yesButtonClass = (surveyValue == '2' ? ' gbl-btn-cancel ' : '');
  const noButtonClass = (surveyValue == '1' ? ' gbl-btn-cancel ' : '');
  return (
    <div>
      <div className="displayInlineB updateKREntryDiv">
        <div
          className={`displayInlineB gbl-btn gbl-btn-slim updateKRYesNoBtn updateKRYesBtn ${yesButtonClass}`}
          onClick={() => btnClicked("2")}
        >
          {i18next.t('Yes')}
        </div>
        <div
          className={`displayInlineB gbl-btn gbl-btn-slim updateKRYesNoBtn updateKRNoBtn ${noButtonClass}`}
          onClick={() => btnClicked("1")}
        >
          {i18next.t('No')}
        </div>
        <input type="hidden" id={`survey_${surveyHidInpId}`} className={surveyHidInpId} />
      </div>
    </div>
  );
}

const NotificationTray = (props) => {
  return (
			<div
				className={`${props.isNew ? "notification-tray-new" : ""
				} notification-tray`}
			>
				<h4
					style={{
					  display: "inline-block",
					  margin: "5px",
					  float: "left",
					  color: "white"
					}}
				>
					{i18next.t('Notifications')}
        </h4>
				<img
					style={{ display: "inline-block", float: "right", margin: "5px" }}
					onClick={() => props.showNotificationWindow()}
					src={`${wbConfig.baseUrl}/images/maximize.png`}
					width={16}
					className="clickable"
				/>
			</div>
  );
}

export default Notifications;
